import React, { useRef, useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
var MyGlobalObject = {}
var PreviousValues = {}

function VelocityChart(props) {
    const chart = useRef(null);
    const root = useRef(null);
    const id = props.id;
    const div = props.div;
    //console.log(props.id, MyGlobalObject[id])

    useLayoutEffect(() => {
        if (props.value === undefined) return;

        if (MyGlobalObject[id]) {
            MyGlobalObject[id].dispose();
        }

        const r = am5.Root.new(div);
        r.setThemes([am5themes_Animated.new(r)]);
        const data = props.value;

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        const chart = r.container.children.push(
            am5radar.RadarChart.new(r, {
                panX: false,
                panY: false,
                startAngle: 180,
                endAngle: 360
            })
        );

        const axisRenderer = am5radar.AxisRendererCircular.new(r, {
            innerRadius: -10,
            strokeOpacity: 0.1
        });
        // axisRenderer.ticks.template.setAll({
        //     forceHidden: true
        // });
        // axisRenderer.grid.template.setAll({
        //     forceHidden: true
        // });


        //axisRenderer.labels.template.setAll({ forceHidden: true });

        const xAxis = chart.xAxes.push(
            am5xy.ValueAxis.new(r, {
                maxDeviation: 0,
                min: 0,
                max: 200,
                strictMinMax: true,
                renderer: axisRenderer
            })
        );

// Add clock hand
// https://www.amcharts.com/docs/v5/charts/radar-chart/gauge-charts/#Clock_hands
var axisDataItem = xAxis.makeDataItem({});
axisDataItem.set("value", 0);

var bullet = axisDataItem.set("bullet", am5xy.AxisBullet.new(r, {
  sprite: am5radar.ClockHand.new(r, {
    radius: am5.percent(99)
  })
}));

xAxis.createAxisRange(axisDataItem);

axisDataItem.get("grid").set("visible", false);

        const prevValue = PreviousValues[id];

        if (prevValue === undefined) {
            axisDataItem.set("value", data);
        } else {
            axisDataItem.set("value", prevValue);
            axisDataItem.animate({
                key: "value",
                to: data,
                duration: 800,
                easing: am5.ease.out(am5.ease.cubic)
            });
        }

        PreviousValues[id] = data;



        /* 
        const axisDataItemN = xAxis.makeDataItem({ value: 0 });

        const clockHandN = am5radar.ClockHand.new(r, {
            pinRadius: 0,
            radius: am5.percent(90),
            bottomWidth: 10
        });

        clockHandN.hand.set("fill", am5.color(0xff0000));
        // do not change angle at all
        clockHandN.adapters.add("rotation", function () {
            return -90;
        });

        axisDataItemN.set(
            "bullet",
            am5xy.AxisBullet.new(r, {
                sprite: clockHandN
            })
        );

        xAxis.createAxisRange(axisDataItemN);

        //south
        var axisDataItemS = xAxis.makeDataItem({ value: 180 });

        var clockHandS = am5radar.ClockHand.new(r, {
            pinRadius: 0,
            radius: am5.percent(90),
            bottomWidth: 10
        });


        // do not change angle at all
        clockHandS.adapters.add("rotation", function () {
            return 90;
        });

        axisDataItemS.set(
            "bullet",
            am5xy.AxisBullet.new(r, {
                sprite: clockHandS
            })
        );

        xAxis.createAxisRange(axisDataItemS);

        function createLabel(text, value, tickOpacity) {
            var axisDataItem = xAxis.makeDataItem({ value: value });
            xAxis.createAxisRange(axisDataItem);
            var label = axisDataItem.get("label");
            label.setAll({
                text: text,
                forceHidden: false,
                inside: true,
                radius: 20
            });

            const tick = axisDataItem
                .get("tick")
                .setAll({
                    forceHidden: false,
                    strokeOpacity: tickOpacity,
                    length: 12 * tickOpacity,
                    visible: true,
                    inside: true
                });
        }

        createLabel("N", 0, 1);
        createLabel("NE", 45, 1);
        createLabel("E", 90, 1);
        createLabel("SE", 135, 1);
        createLabel("S", 180, 1);
        createLabel("SW", 225, 1);
        createLabel("W", 270, 1);
        createLabel("NW", 315, 1);

        for (var i = 0; i < 360; i = i + 5) {
            createLabel("", i, 0.5);
        }
        var newAngle = 0;
        chart.animate({
            key: "startAngle",
            to: newAngle,
            duration: 1000,
            easing: am5.ease.out(am5.ease.cubic)
        });
        chart.animate({
            key: "endAngle",
            to: newAngle + 360,
            duration: 1000,
            easing: am5.ease.out(am5.ease.cubic)
        });

    axisDataItemN.animate({
        key: "value",
        to: am5.math.normalizeAngle(-90 - newAngle),
        duration: 1000,
        easing: am5.ease.out(am5.ease.cubic)
    });
    axisDataItemS.animate({
        key: "value",
        to: am5.math.normalizeAngle(90 - newAngle),
        duration: 1000,
        easing: am5.ease.out(am5.ease.cubic)
    }); 
    */

/* 
        setInterval(function () {
            var newAngle = Math.random() * 360;
            chart.animate({
                key: "startAngle",
                to: newAngle,
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
            chart.animate({
                key: "endAngle",
                to: newAngle + 360,
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
            axisDataItemN.animate({
                key: "value",
                to: am5.math.normalizeAngle(-90 - newAngle),
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
            axisDataItemS.animate({
                key: "value",
                to: am5.math.normalizeAngle(90 - newAngle),
                duration: 1000,
                easing: am5.ease.out(am5.ease.cubic)
            });
        }, 2000);
 */
        // Make chart appear without animation
        chart.appear(0, 0);
        // Commented out animation - uncomment to restore: chart.appear(1000, 100);

        MyGlobalObject[id] = r

        return () => {
            if (MyGlobalObject[id]) {
                MyGlobalObject[id].dispose();
            }
        };


    }, [props.value]);
    return (
        <div id={div} style={{ width: "100%", height: "300px" }}></div>
    );

}

export default VelocityChart;